import * as React from 'react';

interface MobileHeaderProps {
  title: string;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ 
  title
}) => {
  return (
    <header className="sticky top-0 z-40 lg:hidden bg-white border-b border-gray-200 dark:bg-slate-800 dark:border-slate-700">
      <div className="flex items-center justify-center px-4 py-3">
        {/* Centered Title */}
        <h1 className="text-lg font-semibold text-gray-900 dark:text-white truncate">
          {title}
        </h1>
      </div>
    </header>
  );
};

export default MobileHeader;
